<template>
  <div class="space-y-4">
    <h3 class="text-base font-semibold text-gray-900">Nouveau produit</h3>

    <FormField
      id="newProductTitle"
      :modelValue="modelValue.title"
      @update:modelValue="update('title', $event)"
      type="text"
      label="Nom du produit"
      label-class="block text-sm font-medium leading-6 text-gray-900"
      required
    />

    <FormField
      id="newProductReferenceId"
      :modelValue="modelValue.referenceId"
      @update:modelValue="update('referenceId', $event)"
      type="text"
      label="N° de série / référence"
      label-class="block text-sm font-medium leading-6 text-gray-900"
      required
    />

    <FormField
      id="newProductPrice"
      :modelValue="modelValue.price"
      @update:modelValue="update('price', $event)"
      type="number"
      label="Prix d'achat (€)"
      label-class="block text-sm font-medium leading-6 text-gray-900"
      step="0.01"
      min="0"
      required
    />

    <BaseAlert v-if="aboveBand" color="yellow" data-test="above-band-alert">
      <p>{{ t("above_band_alert", { amount: formatPrice(priceBandMax) }) }}</p>
    </BaseAlert>

    <FormField
      id="newProductPurchaseDate"
      :modelValue="modelValue.purchaseDate"
      @update:modelValue="update('purchaseDate', $event)"
      type="date"
      label="Date d'achat"
      label-class="block text-sm font-medium leading-6 text-gray-900"
      required
    />

    <FormField
      id="newProductCurrencyCode"
      :modelValue="modelValue.currencyCode"
      @update:modelValue="update('currencyCode', $event)"
      type="text"
      label="Devise"
      label-class="block text-sm font-medium leading-6 text-gray-900"
    />

    <FormField
      id="newProductVendor"
      :modelValue="modelValue.vendor"
      @update:modelValue="update('vendor', $event)"
      type="text"
      label="Vendeur"
      label-class="block text-sm font-medium leading-6 text-gray-900"
    />

    <FormField
      id="newProductProductType"
      :modelValue="modelValue.productType"
      @update:modelValue="update('productType', $event)"
      type="text"
      label="Type de produit"
      label-class="block text-sm font-medium leading-6 text-gray-900"
    />

    <FormField
      id="newProductImageUrl"
      :modelValue="modelValue.imageUrl"
      @update:modelValue="update('imageUrl', $event)"
      type="text"
      label="URL image"
      label-class="block text-sm font-medium leading-6 text-gray-900"
    />
  </div>
</template>

<script>
import { BaseAlert, FormField, formatPrice } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  components: { BaseAlert, FormField },
  props: {
    modelValue: { type: Object, required: true },
    // Upper bound of the contract's price band: future claims are compensated up to this amount
    priceBandMax: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue", "update:valid"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    aboveBand() {
      const price = Number(this.modelValue.price);
      const priceBandMax = Number(this.priceBandMax);
      return this.priceBandMax != null && Number.isFinite(price) && price > priceBandMax;
    },
    isValid() {
      const np = this.modelValue;
      const price = Number(np.price);
      return (
        Boolean(np.title) && Boolean(np.referenceId) && Number.isFinite(price) && price > 0 && Boolean(np.purchaseDate)
      );
    },
  },

  watch: {
    isValid: {
      immediate: true,
      handler(value) {
        this.$emit("update:valid", value);
      },
    },
  },

  methods: {
    formatPrice,
    update(field, value) {
      this.$emit("update:modelValue", { ...this.modelValue, [field]: value });
    },
  },
};
</script>

<i18n src="./NewProductForm.i18n.json"></i18n>
